export function Services() {
  const services = [
    {
      icon: 'ri-file-edit-line',
      title: 'Manuscript Development',
      description: 'Turn your ideas or rough draft into a structured, compelling manuscript.'
    },
    {
      icon: 'ri-edit-2-line',
      title: 'Professional Editing',
      description: 'Industry-level editing to refine your book for clarity, impact, and quality.'
    },
    {
      icon: 'ri-palette-line',
      title: 'Book Design & Formatting',
      description: 'Beautiful interior formatting and cover design for print and digital platforms.'
    },
    {
      icon: 'ri-global-line',
      title: 'Publishing & Distribution',
      description: 'Launch your book across major publishing platforms including Amazon and global retailers.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Authority Branding Strategy',
      description: 'Position your book as a credibility tool to grow your personal or professional brand.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Marketing & Launch Support',
      description: 'Optional support to help you launch your book and reach your audience.'
    }
  ];

  return (
    <section id="services" className="bg-gradient-to-b from-black via-[#0A0A0A] to-black py-28">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-20">
          <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-4">
            What We Offer
          </div>
          <h2 className="text-white text-5xl font-bold mb-5">
            End-to-End Publishing Services
          </h2>
          <div className="w-20 h-1 bg-[#D4AF37] rounded-full mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-[#1C1C1C] to-[#0F0F0F] rounded-2xl p-8 border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-all duration-300 hover:transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-[#D4AF37]/10 group-hover:bg-[#D4AF37]/20 transition-all duration-300 mb-6">
                <i className={`${service.icon} text-[#D4AF37] text-3xl`}></i>
              </div>
              <h3 className="text-white text-xl font-semibold mb-4 group-hover:text-[#D4AF37] transition-colors">
                {service.title}
              </h3>
              <p className="text-[#999999] text-base leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}